"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_184)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_184`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.0684 5.9895L19.2997 7.31665L20.9425 6.5558L20.0607 8.13692L21.2921 9.46414L19.5158 9.11412L18.6341 10.6953L18.418 8.89784L16.6417 8.54782L18.2844 7.78704L18.0684 5.9895Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-9.6001 0.000732422H26.3999V24.0002H-9.6001V0.000732422Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.600098 -0.00012207H26.3999V24.0002H-0.600098V-0.00012207Z",
					fill: "#01411C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.8467 15.0089C13.6644 16.5858 10.617 16.095 9.04015 13.9126C7.46325 11.7303 7.9541 8.68285 10.1365 7.1061C10.8169 6.61447 11.5815 6.32387 12.3593 6.22276C10.8629 5.99895 9.28125 6.33617 7.9579 7.29228C5.27196 9.23305 4.66783 12.9837 6.60853 15.6697C8.54923 18.3555 12.2999 18.9597 14.9859 17.0189C16.3092 16.0628 17.126 14.6671 17.3833 13.176C17.0431 13.8826 16.5272 14.5173 15.8467 15.0089ZM15.7532 6.15631L16.9826 7.48114L18.6224 6.72163L17.7422 8.29993L18.9714 9.6249L17.1982 9.27559L16.318 10.8541L16.1023 9.05966L14.3291 8.71028L15.969 7.95076L15.7532 6.15631Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_184`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PKFlag };
